<template>
  <IconLucideCopy />
</template>
